import React from 'react';
import heroImage from '../images/hero-image.svg'; 
import backgroundImage from '../images/Rectangle 17.svg';
import { Container, Row, Col } from 'react-bootstrap';
import NewsCard from '../components/NewsCard'; 
import BigNewsCard from '../components/BigNewsCard'; 
import newsArticles from '../data/newsArticles';

  // Get the first article for the BigNewsCard
  const firstArticle = newsArticles[0];

  // Get the next three articles for the NewsCard components
  const nextThreeArticles = newsArticles.slice(1, 4);
  
const AboutPage = () => (
  <>
    {/* Vision Section */}
    <div className="bg-tertiary container-fluid px-5 mb-5 d-flex flex-row align-items-center justify-content-start w-100" style={{ height: '634px' }}>
      <div className="d-flex flex-column align-items-start justify-content-center w-100" style={{ gap: '24px', height: '514.61px' }}>
        <div className="d-flex flex-column align-items-start justify-content-between w-100" style={{ gap: '8px' }}>
          <div className="bg-white p-2 fw-bold display-3">
          <h2 className="text-black fw-bold display-4 fs-2">Nguyen Hoang Medical</h2>
          <h4 className="text-black fw-bold display-3 fs-4">at a Glance</h4>
          </div>
          <p className="text-black pt-2 fs-6" >
          "To be a leading and trusted provider of high-quality pediatric pharmaceuticals and
           advanced medical equipment for ophthalmology, respiratory care, and laboratory diagnostics,
            enhancing healthcare standards and improving patient outcomes nationwide."         
            </p>
        </div>
      </div>
      <div className='d-none d-lg-block align-items-start justify-content-center' style={{ flexShrink: 0, width: '564px', height: '634px', position: 'relative' }}>
        <img
          src={heroImage}
          alt="Medical Supplies"
          className="w-100 h-auto object-fit-cover"
          style={{
            position: 'absolute',
            left: '564px',
            top: '144px',
            transformOrigin: '0 0',
            transform: 'rotate(0deg) scaleX(-1)',
            maxWidth: '564px',
            maxHeight: '490px',
          }}
        />
      </div>
    </div>

    {/* Mission  Section */}
    <div className="bg-dark container-fluid px-5 my-5 d-flex flex-row align-items-center justify-content-start w-100" style={{ height: '634px' }}>
    <div className='d-none d-lg-block align-items-start justify-content-center' style={{ flexShrink: 0, width: '564px', height: '634px', position: 'relative' }}>
        <img
          src={heroImage}
          alt="Medical Supplies"
          className="w-100 h-auto object-fit-cover"
          style={{
            position: 'absolute',
            left: '564px',
            top: '144px',
            transformOrigin: '0 0',
            transform: 'rotate(0deg) scaleX(-1)',
            maxWidth: '564px',
            maxHeight: '490px',
          }}
        />
      </div>

      <div className="d-flex flex-column justify-content-end w-100" style={{ gap: '24px' }}>
      <div className="d-flex flex-column align-items-end justify-content-between w-100" style={{ gap: '8px' }}>
          <h1 className="text-white align-self-start fw-bold display-3 fs-1" >
          Mission 
          </h1>
          <p className="text-white pt-2 fs-6">
          "We are committed to sourcing and delivering premium pharmaceuticals and state-of-the-art medical equipment 
          that support pediatric care, ophthalmology, respiratory health, and laboratory diagnostics. 
          Through innovation, integrity, and strategic partnerships, we ensure healthcare providers have access to reliable,
           safe, and effective products that enhance patient well-being and advance medical excellence." </p>
        </div>
      </div>

    </div>

    {/* Description Section */}
    <div className="container-fluid mx-0 p-0 bg-dark text-white"  style={{marginTop : '300px'}}>
      <div className="row mx-3">
        <div className="col-md-8 offset-md-2 py-4" >
          <img
            src={backgroundImage}// Replace with your image URL
            alt="Pharmaceuticals"
            className="img-fluid rounded-0 mb-4" style={{marginTop : '-250px'}}
          />
          <p className='fs-6'>
          At NH Med, we are dedicated to revolutionizing healthcare by providing
           top-quality medical supplies, pharmaceuticals, and cutting-edge equipment
            to healthcare professionals and institutions worldwide. As a trusted trading 
            partner, we specialize in sourcing and delivering a wide range of essential medical
             products, ensuring reliability, safety, and compliance with international standards.
          </p>
          <p className='fs-6'>
          With a commitment to excellence, innovation, and customer satisfaction, 
          we bridge the gap between manufacturers and healthcare providers, offering
           pediatric pharmaceuticals, ophthalmic solutions, respiratory care equipment,
            and advanced laboratory diagnostics. Our goal is to enhance patient care by 
            ensuring seamless access to the most advanced and cost-effective medical solutions.          </p>
          <p className='fs-6'>
          Driven by integrity and expertise, we work closely with leading global brands and 
          trusted manufacturers to bring the best-in-class healthcare products to hospitals,
           clinics, and pharmacies. At NH Med, we don’t just supply medical products—we deliver
            quality, trust, and innovation that empower healthcare professionals to save lives.          </p>
        </div>
      </div>
    </div>

    {/* Latest News Section */}
  
    <div className="bg-body-tertiary py-5">
      <div className="container d-flex flex-column gap-4 align-items-center">
        <h2 className="fw-bold text-center" style={{ fontSize: '40px' }}>
          Our Latest News &amp; Blogs
        </h2>
        <div className="d-flex gap-4 ">
          {firstArticle && (
            <BigNewsCard
              imageUrl={firstArticle.imageUrl || "rectangle-120.png"}
              category={firstArticle.category || "Doctor"} 
              date={firstArticle.date || "24 Dec, 2023"} 
              title={firstArticle.title || "In this section, we delve into various aspects of health"} 
              description={firstArticle.description || "Explore the world of medical specialties through our blog's spotlight feature. From cardiology to pediatrics, we share in-depth articles written by our expert physicians."} 
              detailsLink={firstArticle.detailsLink}
            />
          )}
          <div className="d-flex flex-column gap-3">
            {nextThreeArticles.map((article, index) => (
              <NewsCard
                key={index}
                imageUrl={article.imageUrl || "rectangle-130.png"} 
                category={article.category || "Doctor"} 
                date={article.date || "24 Dec, 2023"}
                title={article.title || "Discover a treasure trove of practical tips for enhancing"} 
                description={article.description || "From nutrition advice to exercise routines, we're here to support your journey toward a healthier"} 
                detailsLink={article.detailsLink}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  </>
);

export default AboutPage;